import {queryString} from '@securionpay-internal/commons-js';

const BASE64_PREFIX = "B:";

export function encodeFrameParams(params) {
    const paramsJson = JSON.stringify(params);
    const paramsBase64 = encodeBase64(paramsJson);
    return BASE64_PREFIX + paramsBase64;
}

export function decodeFrameParams(encodedParams) {
    if (encodedParams.startsWith(BASE64_PREFIX)) {
        const paramsBase64 = encodedParams.substring(BASE64_PREFIX.length);
        const paramsJson = decode64(paramsBase64);
        return JSON.parse(paramsJson);

    } else {
        return queryString.parse(encodedParams);
    }
}

function encodeBase64(str: string) {
    const bytes = new TextEncoder().encode(str);
    let binString = '';
    
    for (let i = 0; i < bytes.length; i++) {
        binString += String.fromCodePoint(bytes[i]);
    }
    
    return btoa(binString);
}

function decode64(base64: string) {
    const binString = atob(base64);
    const bytes = Uint8Array.from(binString, (m) => m.codePointAt(0));
    return new TextDecoder().decode(bytes);
}

